// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Andmekogu",
        "pull_refresh": "Tõmmake värskendama",
        "release_refresh": "Väljaanne värskendamiseks",
        "refresh_loading": "Laadimine ...",
        "footer_text": "Teenused pakub Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Otsiriik/piirkond",
        "my_flow": "Minu andmed",
        "charge_code": "Vautšerkood",
        "coupons": "Kupongid",
        "local_package": "Kohalikud andmed",
        "more": "Rohkem",
        "popular_destination": "Riik/piirkond",
        "buy_now":"Osta kohe",
        "package_useing": "Aktiivne",
        "unused": "Epäaktiivne",
        "download_app": "Laadige alla rakendus",
        "enter_the_mall_list": "Sisenege kaubanduskeskuse loendisse",
        "no_data": "Andmeid pole veel",
        "no_data_available": "Andmed pole saadaval",
        "copy_success": "Kopeerimine õnnestus",
        "copy_fail": "Kopeerimine nurjus",
        "meritsTitle": "Mis on eelised?",
        "merits1": "SIM-i vaja pole & Kuukausimakseid pole",
        "merits2": "Integreeritud top 2-3 operaatoriga automaatse võrguvahetuse jaoks",
        "go_buy": "Osta nüüd",
        "instant_savings": "Säästa",
        "expires_in": "Aegub",
        "download_app_tips": "Laadi alla rakendus, et saada rohkem pakkumisi ja kogemusi"
    },
    "packages": {
        "sub_title": {
            "us": "Välja arvatud Guam, Saipan",
            "it": "Sealhulgas Vatikani linn, San Marino",
            "va": "Sealhulgas Itaalia, San Marino",
            "sm": "Sealhulgas Itaalia, Vatikani linn",
            "ma": "Sealhulgas Lääne -Sahara",
            "eh": "Sealhulgas Maroko",
            "ch": "Sealhulgas liechtenstein",
            "li": "Sealhulgas Šveits",
            "fr": "Sealhulgas Monaco",
            "mc": "Sealhulgas Prantsusmaa",
            "fi": "Sealhulgas Alandi saared",
            "ax": "Sealhulgas Soome",
            "gu": "Sealhulgas Põhja -Mariana saared",
            "mp": "Sealhulgas Guam"
        },
        "unlimited_packages": "Piiramatu andmepakett",
        "normal_packages": "Tavaline andmepakett",
        "multi_region_packages": "Mitme regiooniga",
        "regional_data": "Regionaalsed andmed",
        "high_speed_text": "kiired andmed",
        "infiniteFlow": "Piiramatud andmed",
        "unLimitData": "Piiramatu",
        "high_speed_text_year": "Kiire kiirus/parlamendiliige",
        "package_list": "Paketiloend",
        "special_offer": "Allahindlused",
        "first_month": "1. Kuu",
        "periodUnit": {
            "day": "päev",
            "month": "kuu",
            "hour": "tund",
            "year": "aasta"
        },
        "periodUnits": {
            "day": "päev",
            "month": "kuud",
            "hour": "tund",
            "year": "aastaid"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "jaoks",
            "hour": "h",
            "year": "selle"
        },
        "periodUnitMonthly":"Kuuane",
        "periodUnitsSimp": {
            "day": "d",
            "month": "jaoks",
            "hour": "h",
            "year": "selle"
        },
        "unlimited_good_name": {
            "day": "Päevapass",
            "month": "Igakuine pass",
            "year": "Iga-aastane pass"
        },
        "continuousMonth": "Pidevad kuud",
        "continuousDay": "Pidevad päevad",
        "continuousYear": "Pidevad aastad",
        "day_invalid": "Aeguvad praegusel päeval",
        "month_invalid": "Aeguvad jooksval kuul",
        "immediate_valid": "Jõustub kohe",
        "tomorrow_day_valid": "Efektiivne alates järgmisest päevast",
        "tomorrow_month_valid": "Efektiivne alates järgmisest kuust",
        "detail": {
            "cell_flow": "Andmed",
            "cell_period": "Kehtivus",
            "buy_quantity": "Summa",
            "use_area": "Katvus",
            "use_intro": "Tingimused",
            "buy_btn": "Tellimus",
            "pay": "Maksma",
            "buy_tips": "Teil on %@packageName-pakett kasutusel. Kas soovite selle paketi osta?",
            "haveOrderTips": "Loodud maksmisega ootav tellimus. Klõpsake Kinnita, et minna oma andmesälle！"
        },
        "confirm": {
            "title": "Tellimuse kinnitus",
            "real_pay_amount": "Makstud summa",
            "online_payment": "Veebimakse",
            "create_order_error": "Seadistamine ebaõnnestus"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Tellimuse oleku saamine ...",
            "buy_success": "Tellimus täielik",
            "buy_pending": "Kuni kinnituseni",
            "buy_pending_tip": "Makse protsessis ... Kui makse ei kannud 10 minuti jooksul, võtke abi saamiseks meiega ühendust.",
            "get_payment_info_fail": "Makseteabe omandamine ebaõnnestus",
            "cell_package": "Pakk",
            "cell_buy_amount": "Alamtotaalne",
            "cell_real_amount": "Makstud summa",
            "go_to_order_btn": "Minge minu paketi juurde",
            "back_home": "Tagasi koju",
            "back_mall": "Tagasi kaubanduskeskusesse",
            "ordersn_empty": "Tellimus sn ei saa olla tühi",
            "order_search_error": "Ootamatu viga",
            "goodsName": 'Tootenimi'
        },
        "fail": {
            "payment_fail": "Makse ebaõnnestus",
            "back_home": "Tagasi koju"
        }
    },
    "CountryGroup": {
        "title": "Riik/piirkond",
        "placeholder": "Otsinguriik või piirkond",
        "clear": "Selge",
        "history": "Otsinguajalugu"
    },
    "PromotionCode": {
        "verification": {
            "title": "Vautšerkood",
            "minititle": "Vautšerkood",
            "input": "Palun sisestage ülakood",
            "explain": "Näpunäited: puudutage paremas ülanurgas asuvat skannimisnuppu, et skannida vautšerikaardi QR -koodi või sisestada vautšeri kood käsitsi (juhtumitundlik), kui see ei tööta.",
            "submit": "Alluma",
            "exchange": "Lunastama",
            "cancel": "Tühistama",
            "Inquiry": "Kas vahetage kindlasti",
            "ErrorCode": "Laadimiskoodi viga"
        },
        "recharge_success": {
            "package": "Pakk",
            "content": "Edukalt lunastatud",
            "back": "Tagasi kaubanduskeskusesse",
            "view_packets": "Minge minu paketi juurde"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktiveeritud",
            "isFirst": "Prioriteetseks seatud",
            "toFirst": "Seatud prioriteediks",
            "inactive": "Inaktiveeritud"
        },
        "periodUnits": {
            "minute": "minut",
            "hour": "tund",
            "day": "päev",
            "month": "kuud"
        },
        "useIntro": {
            "tip1": "Piiramatu andmepaketil on kõrgem prioriteet kui helitugevuse andmepaketi.",
            "tip2": "Kasutusprioriteet põhineb sama tüüpi paketi ostukuupäeval, st kõigepealt kasutatakse kõige varasema ostukuupäevaga paketti, samas kui ühe regioonipakettide prioriteet on kõrgem kui piirkondlik pakett.",
            "tip3": "Samuti saate käsitsi reguleerida sama tüüpi pakettide kasutamise prioriteeti."
        },
        "myFlow": "Minu andmed",
        "remainingFlow": "Andmed jäänud",
        "remainingTime": "Kehtiv vasakpoolne",
        "remainingHighFlow": "Kiire andmed on jäänud",
        "validPeriod": "Kehtivus",
        "noneFlow": "Andmepaketti pole",
        "noneFlowTip": "Palun ostke andmepakett ja nautige kvaliteetset võrku",
        "buyPackFlow": "Ostsa pakette",
        "checkInvalidFlow": "Kontrollige aegunud andmepaketti",
        "orderList": {
            "title": "minu korraldused",
            "amount_paid": "Kokku",
            "device": "Omanduses olev seade",
            "order_details": "Tellimuse üksikasjad",
            "total_amont": "Vahesumma",
            "orderSN": "Tellimus nr.",
            "createTime": "Loomise aeg",
            "cancelTime": "Suletud aeg",
            "payTime": "Tellimuse aeg",
            "unsubTime": "Tühistatud aeg",
            "payMethod": "Makseviis",
            "thirdSN": "Tehingu nr.",
            "delete": "Kustuta",
            "cancel": "Tühista tellimus",
            "unsub": "Tagasimakse",
            "goto_cancel": "Kas soovite tellimuse tühistada?",
            "goto_unsubscribe": "Kas soovite tellimusest loobuda?",
            "delete_Tips": "Tellimust ei saa pärast kustutamist jätkata, seetõttu ei saa teie hooldusjärgseid probleeme käsitleda.Kas olete kindel, et kustutate selle?",
            "status_success": "Lõpetatud",
            "status_pending": "Tasumata",
            "status_cancel": "Suletud",
            "status_unsub": "Tühistatud",
            "payMethod_stripe": "Krediitkaart"
          },        
    },
    "registerlogin": {
        "create_account_tip":"Looge konto, alustage eksklusiivset kogemust",
        "select_country_tip":"Seade kasutage riiki/piirkonda",
        "email_name": "Post",
        "phone_name": "Telefon",
        "email_address": "E-posti aadress",
        "password": "parool",
        "country": "riik",
        "select_country": "Valige riik",
        "cancel": "Tühistama",
        "confirm": "Kindel",
        "please_enter": "Sisestage 6-20 tähemärki (tähtede, numbrite või sümbolite kombinatsioon)",
        "select_country_tips": "Riikide valik on kohalike pakettide vaatamiseks. Pärast registreerimist ei saa seda muuta. Palun kinnitage!",
        "global_roaming": "Rahvusvaheline domeenikood",
        "phone_number": "telefoninumber",
        "agree": "nõustuma",
        "user_agreement": "Kasutajaleping",
        "and": "ja",
        "privacy_policy": "Privaatsuspoliitika",
        "register_login": "Registreeruge või logige sisse",
        "login_error": "Logide arv on liiga sagedane, proovige hiljem uuesti!",
        "register_error": "Registreerimiste arv on liiga sagedane, proovige hiljem uuesti!",
        "forgot_pwd": "Unustage parool",
        "app_tips": "Logige selle kontoga sisse rakendusse pärast selle allalaadimist, et juurdepääsu rohkem funktsioonidele.",
        "download_app": "Minge rakenduse alla laadima",
        "rememberPwd": "Pidage meeles parooli",
        "third_login": "Jätkuma",
        "agreement_tips": "Kontrollige kasutajalepingut ja privaatsuspoliitika kasti",
        "selectCountry_tips": "Pange tähele, et registreeritud riik mõjutab otseselt järgmisi makseviise ja valuutasid, valige vastavalt oma vajadustele.",
        "login_error_cancel": "Kasutaja katkestas sisselogimise",
        "login_error_auth": "Lubage brauseri seadmetest hüpikaknad",
        "device_tips": "Seade ootab aktiveerimist. Töötlemine 24 tunni jooksul."
    },
    "forgotPwd": {
        "forgot_pwd": "Unustage parool",
        "email_address": "E-posti aadress",
        "next": "Järgmine",
        "email_has_been_sent": "Oleme saatnud e-posti aadressile %@email aadressile. Klõpsake lingil ja järgige parooli hankimiseks samme.",
        "have_retrieved_it": "Olen selle leidnud",
        "unable_to_receive_email": "Kas te ei saa meili vastu võtta? Kontrollige, kas teie rämpsposti ja kustutatud kirjade kataloogis on e-kirju aadressilt %@email",
        "or": "või",
        "resend": "Taasalustama",
        "global_roaming": "Rahvusvaheline domeenikood",
        "phone_number": "telefoninumber",
        "verification_code_has_been_sent": "Oleme kinnituskoodi saatnud aadressile:",
        "verification_code": "Kinnituskood",
        "no_verification_code_received": "Kas ei saanud kinnituskoodi?",
        "please_enter": "Sisestage 6-20 tähemärki (tähtede, numbrite või sümbolite kombinatsioon)",
        "reset_password": "Lähtestage parool",
        "reset_successful": "Lähtestage edukalt"
    },
    "coupons": {
        "coupons_name": "Kupongid",
        "no_coupons": "Pole veel kuponge",
        "no_data": "Andmeid pole veel",
        "applicable_to_the_following": "Kupongid sobivad järgmise andmepaketi jaoks"
    },
    "digital":{
        "title":"Seade SN",
        "purchased":"Minu ostud",
        "viewAll":"Rohkem",
        "skinStore":"Tootepood",
        "completed":"Ostetud",
        "goBuy":"Ostma",
        "order": {
          "title":"Ostetud tellimused"
        },
        "detail": {
          "describe":"Kirjeldus"
        }
    },
    "viewPL": {
        "other": 'teised'
    },
    "invalidFlow": {
        "stateName": "Olek",
        "state": {
            "NOT_ACTIVATED": "Inaktiveeritud",
            "IN_USING": "Saadav",
            "USE_END": "Kurnatud",
            "EXPIRE": "Aegunud",
            "TRANSFER": "Ülekandmine",
            "UNSUBSCRIBE": "Tühistama",
            "VALID": "Kehtiv",
            "INVALID": "Kehtetu",
            "EXCHANGE_POINTS": "Punkte lunastama"
        },
        "noneFlow": "Aegunud andmepaketi pole",
        "pageName": "Aegunud andmepakett"
    },
    "flowDetail": {
        "title": "Andmete üksikasjad",
        "flow": "Andmed",
        "validTime": "Kehtiv algus",
        "invalidTime": "Kehtib kuni",
        "coverage": "Katvus",
        "useIntro": "Tingimused",
        "purchaseTime": "Ostetud kell",
        "subtotal": "Alamtotaalne",
        "status": "Olek",
        "cancel": "Tühistama",
        "buyAgain": "Osta see uuesti",
        "validity": "Kehtivus",
        "tip": "Teade",
        "cancelTip": "Kas olete kindel, et soovite selle paketi tagasi maksta?",
        "dataLeft": "Andmed jäänud"
    },
    "netError": {
        "try_again": "Proovige uuesti",
        "net_error": "Võrk pole",
        "try_again_desc": "Palun kontrollige võrguseadet ja proovige uuesti"
    },
    "loadFail": {
        "try_again": "Proovige uuesti",
        "load_fail": "Laadimine ebaõnnestus",
        "load_fail_desc": "Andmete laadimine ebaõnnestus, proovige uuesti",
        "IMEI_Not_Exist": "IMei pole olemas, palun proovige siseneda paremast sissepääsust",
        "Project_Not_Exist": "Ilmneb viga. Võtke ühendust klienditeenindusega. (01)",
        "commonError": "Ilmneb viga. Võtke ühendust klienditeenindusega."
    },
    "settlement_Easy_and_convenient": "Lihtne ja mugav",
    "settlement_Great_deal": "Palju",
    "settlement_Safe_and_secure": "Ohutu ja turvaline",
    "settlement_Autopay_service_regulation": "AutoPay teenuse reguleerimine",
    "settlement_Read": "Lugema",
    "settlement_No_coupon": "Pole kupongi",
    "settlement_Subtotal": "Alamtotaalne",
    "settlement_Coupon": "Kupong",
    "settlement_TOTAL": "Kogusumma",
    "settlement_promotion_tip": "Sooduspakkumist ei saa kasutada koos kupongidega",
    "settlement_coupon_tip": "Kupongi ei saa kasutada koos ühegi muu reklaampakkumisega",
    "member_myFlow_noList": "Andmeid puuduvad",
    "detail_se_content": "Turvaline, lihtne ja mugav viis. Võite igal ajal tellimuse tühistada",
    "Enter_Promo_code": "Reklaamikood",
    "Enter_Promo_Coupon": "Kupongid",
    "settlement_Not_used_coupon": "Kuponk pole kasutatud",
    "settlement_Available_coupon": "Saadav",
    "settlement_Unavailable_coupon": "Kättesaamatu",
    "please_Enter_Promo_code": "Sisestage reklaamikood",
    "please_Select_Coupon_use": "Valige kupongi, mida soovite kasutada.",
    "Buy_Now": "Osta kohe",
    "Dont_Use_Any": "Ära kasuta ühtegi",
    "settlement_confirm": "Kinnitama",
    "settlement_tips": "Kinnitama",
    "flowDetail_unsubscribe": "Tellimuse tühistamine",
    "flowDetail_unsubscribed": "Tellimata",
    "flowDetail_isCancelPackage": "Tühistada see pakett?",
    "flowDetail_confirmAgreementUnsubscribe": "Pärast tellimusest loobumist ei saa teil olla palju. Kas olete kindel, et soovite tellimust tühistada?",
    "flowDetail_cancel": "Tühistama",
    "flowDetail_cancelSuccess": "Tellimusest loobumine edukalt",
    "packages_detail_promotion": "Edutamine",
    "orderTips":{
        "iDay" : "päev",
        "iDays" : "päevad",
        "iMonth" : "kuu",
        "iMonths" : "kuud",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol Teie esimesel ostmisel, Makske hiljem %@money/%@periodSymbol, Võite igal ajal tellimuse tühistada",
        'Monthly_discount':"Salvestage %@saveMoney iga %@period! Võite igal ajal tellimuse tühistada",
        'Ordinary_monthly_package':"Turvaline, lihtne ja mugav viis. Võite igal ajal tellimuse tühistada",
        "AlreadyPurchased":'Vabandust, et saate praegu tellida ainult ühe andmepaketi. Palun tellige tellimusest “%@” ja tellige hiljem pärast selle aegumist soovitud paketti.',
        "Contract_recommendation_First":'<label>AutoPay teenuse abil, siis oma esimesel ostmisel</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Võite igal ajal tellimuse tühistada'
        +'<a class="btn">Tellima ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>AutoPay teenuse korral makske ainult</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Võite igal ajal tellimuse tühistada'
        +'<a class="btn">Tellima ></a></p>',
        "Contract_recommendation_General":"<label>AutoPay teenusega</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Turvaline, lihtne ja mugav viis. Võite igal ajal tellimuse tühistada'
        +'<a href="javascript:;" class="btn">Tellima ></a></p>',
        'BanlanceDoubleCheck':'Kas olete kindel, et soovite maksta bilansiga?',
    },
    feedback: {
        title: "tagasiside",
        placeholder: "Sisenege riiki, mida soovite külastada, või muid küsimusi ning vastame teie vajadustele nii kiiresti kui võimalik!",
        submit: "Esita",
        submit_success: "Esitamine edukalt",
        other_opinions: "Muud arvamused",
    },
    view_country_input: 'Palun sisestage oma konto',
    "select_package": {
        "title": "Valige Andmed",
        "allPackage": "Kõik Andmed",
        "type": "Tüüp",
        "flow": "Andmed",
        "month_package": "Kuuplaan",
        "flow_package": "Andmepakett",
        "time": "Kestus",
        "period": "Tsükkel",
        "auto_debit": "Auto-Debit Info",
        "auto_subscribe": "Auto-Pikendamine",
        "detail": "Andmete Detailid",
        "carrier": "Toetatud Operaatorid",
        "country": "Kattud Riigid",
        "notice": "Ostukoguide"
    }
}